import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetWallet } from "../../../slice/walletSlice";

const Main = ({ children }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  //   useEffect(() => {
  //     const unlisten = history.listen((location) => {
  //       console.log("Path changed to:", location.pathname); // Debugging line
  //       if (!location.pathname.startsWith("/DisplayAuctions")) {
  //         console.log("Resetting wallet"); // Debugging line
  //         dispatch(resetWallet());
  //       }
  //     });

  // Cleanup listener on component unmount
  // return () => {
  //   unlisten();
  // };
  // if (!location.pathname.startsWith("/DisplayAuctions")) {
  //   console.log("Resetting wallet"); // Debugging line
  //   dispatch(resetWallet());
  // }
  //   }, [location.pathname, dispatch]);
  const [currentPath, setCurrentPath] = useState(window.location.href);

  useEffect(() => {
    const checkUrlChange = () => {
      if (window.location.href !== currentPath) {
        setCurrentPath(window.location.href);
        if (!window.location.pathname.startsWith("/DisplayAuctions")) {
          dispatch(resetWallet());
        }
      }
    };

    const intervalId = setInterval(checkUrlChange, 1000); // Check every second

    return () => clearInterval(intervalId);
  }, [currentPath, dispatch]);

  return <>{children}</>;
};

export default Main;
